<template>
  <div style="max-width: 120rem; margin: auto;">
    <b-card title="Alert">
      <b-form
        ref="form"
        :style="{height: trHeight}"
        class="repeater-form"
        @submit.prevent="repeateAgain"
      >

        <!-- Row Loop -->
        <b-row
          v-for="(item, index) in items"
          :id="item._id"
          :key="item._id"
          ref="row"
        >

          <!-- Item Name -->
          <b-col md="2">
            <b-form-group
              label="Name"
              label-for="item-name"
            >
              <b-form-input
                id="item-name"
                type="text"
                placeholder="Title"
                v-model="item.title"
              />
            </b-form-group>
          </b-col>

          <!-- Cost -->
          <b-col md="4">
            <b-form-group
              label="Message"
              label-for="message"
            >
              <b-form-input
                id="message"
                type="text"
                v-model="item.message"
                placeholder="Message"
              />
            </b-form-group>
          </b-col>

          <!-- Quantity -->
          <b-col md="2">
            <b-form-group
              label="Show for User"
              label-for="quantity"
            >
              <v-select
                multiple
                append-to-body
                :options="userList"
                label="username"
                :reduce="user => user._id"
                v-model="item.uid"
              />
            </b-form-group>
          </b-col>
          <b-col md="2">
            <b-form-group
              label="Variant"
              label-for="quantity"
            >
              <b-form-select
                v-model="item.variant"
                :options="variants"
              />
            </b-form-group>
          </b-col>

          <!-- Profession -->
          <b-col
            lg="1"
            md="1"
          >
            <b-form-group
              label="Show"
              label-for="price"
            >
              <b-form-checkbox
                class="mt-0 mt-md-1"
                v-model="item.show"
              >
              </b-form-checkbox>
            </b-form-group>
          </b-col>

          <!-- Remove Button -->
          <b-col
            lg="1"
            md="1"
          >
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              class="btn-icon mt-0 mt-md-2"
              @click="saveAlert(item)"
            >
              <feather-icon icon="SaveIcon" />
            </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              class="btn-icon mt-0 mt-md-2"
              @click="removeItem(item._id)"
            >
              <feather-icon icon="XCircleIcon" />
            </b-button>
          </b-col>
          <b-col cols="12">
            <hr>
          </b-col>
        </b-row>
      </b-form>
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        @click="repeateAgain"
      >
        <feather-icon
          icon="PlusIcon"
          class="mr-25"
        />
        <span>Add New</span>
      </b-button>
      
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BButton,  BFormGroup, BFormInput, BInputGroup, BInputGroupAppend, BCardHeader, BCardTitle, BCardBody, BForm, BFormCheckbox, BFormSelect
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import BCardActions from '@/@core/components/b-card-actions/BCardActions.vue'
import RepositoryFactory from '../../api/RepositoryFactory'
const Settings = RepositoryFactory.get('settingsmanager')
const UserManagersRepository = RepositoryFactory.get('usermanagers')
import { heightTransition } from '@core/mixins/ui/transition'
import vSelect from 'vue-select'
export default {
  components: {
    BCard,
    BRow,
    BCol,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BCardActions,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BFormCheckbox,
    BFormSelect,
    vSelect
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      items: [],
      userList: [],
      variants:[
        "success",
        "warning",
        "danger"
      ],
    }
  },
  created(){
    window.addEventListener('resize', this.initTrHeight)
   

    Settings.fetchUserList().then(rs=>{
      this.userList = rs.data.data.map(x=> {
        return {
          _id: x._id,
          username: x.username
        }
      })

      Settings.fetchUAlerts().then(rs=>{
        this.items = rs.data.data
      })
    }).catch(e=>{

    })
  },
  destroyed() {
    window.removeEventListener('resize', this.initTrHeight)
  },
  methods:{
    repeateAgain() {
      Settings.createUAlert().then(rs=>{
        this.items.push(rs.data.alert)
        this.$nextTick(() => {
          console.log(this.$refs.row[0].offsetHeight)
          this.trAddHeight(this.$refs.row[0].offsetHeight)
        })
      })
    },
    removeItem(id) {
      Settings.deleteUAlert(id).then(rs=>{
        let index = this.items.findIndex(x=>x._id == id)
        if(index > -1){
          this.items.splice(index, 1)
          this.trTrimHeight(this.$refs.row[0].offsetHeight)
        }
      });
    },
    saveAlert(item){
      //console.log(item.uid)
      Settings.saveUAlert(item._id,item).then(rs=>{
      })
    },
    initTrHeight() {
      this.trSetHeight(null)
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight)
      })
    },
  }
}
</script>
<style lang="scss" scoped>
.repeater-form {
  overflow: hidden;
  transition: .35s height;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>